import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Checkbox, Box } from '@mui/material'; 
import { IconButton } from '@material-ui/core';

import EditIcon from '@mui/icons-material/Edit';



function createData(name, code, population, size) {
  const density = population / size;
  return { name, code, population, size, density };
}

const rows = [
{
    id:1,
    category_name:'Primary',
    description:'',
    status:true
},
{
    id:2,
    category_name:'Primary',
    description:'',
    status:false
},
{
    id:3,
    category_name:'Primary',
    description:'blaah blaah blaah',
    status:true
},
{
    id:4,
    category_name:'Primary',
    description:'testing testing',
    status:false
},
{
    id:5,
    category_name:'Primary',
    description:'',
    status:true
},
{
    id:6,
    category_name:'Primary',
    description:'',
    status:true
},
{
    id:7,
    category_name:'Primary',
    description:'testing testing',
    status:false
},
{
    id:8,
    category_name:'Primary',
    description:'',
    status:true
},
{
    id:9,
    category_name:'Primary',
    description:'',
    status:true
},
{
    id:10,
    category_name:'Primary',
    description:'testing testing',
    status:false
},
{
    id:11,
    category_name:'Primary',
    description:'',
    status:true
},
{
    id:12,
    category_name:'Primary',
    description:'',
    status:true
},
];

export default function OrderReportTable({title}) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);


  const columns = [
    { id: 'cmy', label: 'CMY', minWidth: 170 },
    { id: 'Customer name', label: ` Customer Name `, minWidth: 100 },
    {
      id: 'address',
      label: 'Address',
      minWidth: 170,
      align: 'right',
      format: (value) => value.toLocaleString('en-US'),
    },
    {
      id: 'order no',
      label: 'Order No',
      minWidth: 170,
      align: 'right',
      format: (value) => value.toLocaleString('en-US'),
    },
    {
      id: 'order date',
      label: 'Order Date',
      minWidth: 170,
      align: 'right',
      format: (value) => value.toLocaleString('en-US'),
    },
    {
      id: 'po no',
      label: 'Po No',
      minWidth: 170,
      align: 'right',
      format: (value) => value.toLocaleString('en-US'),
    },
    {
      id: 'item name',
      label: 'Item Name',
      minWidth: 170,
      align: 'right',
      format: (value) => value.toLocaleString('en-US'),
    },
    {
      id: 'item code',
      label: 'Item Code',
      minWidth: 170,
      align: 'right',
      format: (value) => value.toLocaleString('en-US'),
    },
    {
      id: 'hsn',
      label: 'HSN',
      minWidth: 170,
      align: 'right',
      format: (value) => value.toLocaleString('en-US'),
    },
    {
      id: 'tax rate',
      label: 'Tax Rate',
      minWidth: 170,
      align: 'right',
      format: (value) => value.toLocaleString('en-US'),
    },
   
  ];


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper sx={{ width: '100%' }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                //   align={column.align}
                //   style={{ top: 0, minWidth: column.minWidth }}
                >
                  <b>{column.label}</b>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                        <TableCell >{row.id}</TableCell>
                        <TableCell >{row.category_name}</TableCell>
                        <TableCell >{row.description}</TableCell>
                        <TableCell >{row.category_name}</TableCell>
                        <TableCell >{row.description}</TableCell>
                        <TableCell >{row.category_name}</TableCell>
                        <TableCell >{row.description}</TableCell>
                        <TableCell >{row.description}</TableCell>
                        <TableCell >{row.category_name}</TableCell>
                        <TableCell >{row.description}</TableCell>
                                      
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}